const buildGcpLogsUrl = (requestId: string): string => {
  const query = `resource.labels.project_id="lao-multisite"\nresource.type="k8s_container"\nlabels.requestId="${requestId}"`;
  const encodedQuery = encodeURIComponent(query);

  return `https://console.cloud.google.com/logs/query;query=${encodedQuery};timeRange=PT1H`;
};

export default buildGcpLogsUrl;
